export const BookOutlineIcon = (props) => (
  <svg fill="none" height={18} stroke="currentColor" strokeWidth={1.6} viewBox="0 0 24 24" width={18} {...props}>
    <path
      d="M12 6.042A8.967 8.967 0 0 0 6 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 0 1 6 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 0 1 6-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0 0 18 18a8.967 8.967 0 0 0-6 2.292m0-14.25v14.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
